// extracted by mini-css-extract-plugin
export default {"Logo":"Logo_Logo__2Qh+R","Light":"Logo_Light__XTIRP","Dark":"Logo_Dark__Q1Oe6","country":"Logo_country__2OaQc"};